import {
  ACL_CUSTOM_PAGES_PROFILE_MANAGE,
  ACL_ORGANIZATION_LIST_OWNED_CONTRACTS,
  ACL_ORGANIZATION_MANAGE,
  ACL_ORGANIZATION_USERS_MANAGE,
  ACL_PUSH_LOG_MANAGE,
  ACL_SITE_SHARE,
  ACL_TLS_OPTIONS_MANAGE,
  AuthService,
} from '@shared/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { OrganizationContractService } from '@shared/services/contract.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLinkBase,
  NgbNavLinkButton,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import { OrganizationComponent } from './organization/organization.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { OrganizationUsersComponent } from './organization-users/organization-users.component';
import { SentSharesComponent } from './sent-shares/sent-shares.component';
import { ReceivedSharesComponent } from './received-shares/received-shares.component';
import { FeatureFlagDirective } from '@shared/utils/feature-flag.directive';
import { CustomPagesProfilesComponent } from './custom-pages-profiles/custom-pages-profiles.component';
import { PushLogComponent } from './push-log/push-log.component';
import { LabelBetaComponent } from '@shared/components/label-beta/label-beta.component';
import { TlsOptionsComponent } from './tls-options/tls-options.component';
import { MyContractsComponent } from './my-contracts/my-contracts.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-my-organization',
  templateUrl: './my-organization.component.html',
  styleUrls: ['./my-organization.component.scss'],
  imports: [
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLinkButton,
    NgbNavLinkBase,
    RouterLink,
    NgbNavContent,
    OrganizationComponent,
    NgIf,
    OrganizationUsersComponent,
    SentSharesComponent,
    ReceivedSharesComponent,
    FeatureFlagDirective,
    CustomPagesProfilesComponent,
    PushLogComponent,
    LabelBetaComponent,
    TlsOptionsComponent,
    MyContractsComponent,
    NgbNavOutlet,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class MyOrganizationComponent implements OnInit {
  activeTab: Tab = 'parameters';
  hasContract$: Observable<boolean>;

  protected readonly userFeatures = new Set(this.auth.user.features);

  constructor(
    private route: ActivatedRoute,
    protected auth: AuthService,
    private contractService: OrganizationContractService,
  ) {
    this.hasContract$ = this.auth.userHasFeature(ACL_ORGANIZATION_LIST_OWNED_CONTRACTS)
      ? this.contractService
          .getOwnedContracts({}, { number: 0, size: 1 })
          .pipe(map((page) => (page?.content?.length ?? 0) > 0))
      : of(false);
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.activeTab = params['tab'] || 'parameters';
    });
  }

  protected readonly ACL_ORGANIZATION_USERS_MANAGE = ACL_ORGANIZATION_USERS_MANAGE;
  protected readonly ACL_SITE_SHARE = ACL_SITE_SHARE;
  protected readonly ACL_ORGANIZATION_MANAGE = ACL_ORGANIZATION_MANAGE;
  protected readonly ACL_PUSH_LOG_MANAGE = ACL_PUSH_LOG_MANAGE;
  protected readonly ACL_TLS_OPTIONS_MANAGE = ACL_TLS_OPTIONS_MANAGE;
  protected readonly ACL_CUSTOM_PAGES_PROFILE_MANAGE = ACL_CUSTOM_PAGES_PROFILE_MANAGE;
}

type Tab =
  | 'parameters'
  | 'users'
  | 'sentShares'
  | 'receivedShares'
  | 'export'
  | 'tlsOptions'
  | 'myContracts'
  | 'errorHandling';
